import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

import DefaultImageIcon from "../../../assets/images/common/imageloading.gif";

import './index.scss';

import CustomTooltip from "../../ui/Tooltip";
// import OverflowText from "../../ui/Textoverflow";

import { emailVerifiedIcon, emailNotVerifiedIcon } from "../../../utils/icons";

const ProfileAvatar = ({imageUrl, type, firstName, lastName, name, tags, tagContent, tagColor, pageType, secondaryText, imageType="round", emailVerifiedStatus=""}) => {

    const { t } = useTranslation();

    const [imgSrc, setImgSrc] = useState(DefaultImageIcon);
    const [hasError, setHasError] = useState(false)

    const handleImageLoad = () => {
        setImgSrc(imageUrl);
    };
    
    const handleImageError = () => {
        if(hasError) {
            setHasError(true)
            setImgSrc(DefaultImageIcon);
        }        
    };

    useEffect(() => {
        // Update the image source when the imageUrl prop changes
        if (imageUrl) {
          setImgSrc(imageUrl);
        } else {
          setImgSrc(DefaultImageIcon);
        }
    }, [imageUrl]);

    return (
        <div className='profile-avatar-container'>
            <div className={`image-container ${imageType === "square" ? "square" : ""}`}>
                {imageUrl && (
                    <img className="avatarImage" alt="avatar" src={imgSrc} onLoad={handleImageLoad}
                    onError={handleImageError} />
                )}
            </div>
            <div className="name-container">
                {type==="profile" && pageType === "organizationDetails" && <p className="organization-details-createdby">{t("organizationDetailsPage.createdBy")}</p>}
                {type==="profile" && <p className="avatar-primary--text">{firstName} {lastName}</p>}
                {type === "profile" && emailVerifiedStatus !== "" && <div className="email-status">
                    <CustomTooltip position={"top"} content={emailVerifiedStatus === "verified" ? "Email verified" : "Email not verified"}>
                    
                    {emailVerifiedStatus === "verified" ? emailVerifiedIcon() : emailNotVerifiedIcon()} </CustomTooltip></div>
                    
                }
                {tags && <span className={`position-relative tag-content ${tagColor}`}>
                        <span>{tagContent}</span>
                    </span>}
                {type==="domain" && <p className="avatar-primary--text">{name}</p>}
                {secondaryText && <p className="avatar-secondary--text">{secondaryText}</p>}
                {/* {secondaryText && <OverflowText className={"avatar-secondary--text"} text={secondaryText}>
                </OverflowText>} */}
            </div>
        </div>
    )
}

export default ProfileAvatar;